import type { BaseColors, BetTypeColors } from '../types/BaseTheme';

const jokerOrange = '#EB7438';
const spelvardeRed = '#FF4C29';
const storavinsterBlue = '#001E5B';
const travfaktaGreen = '#00C95D';
const travogatLightBlue = '#00B9FB';
const travrondenSpelBlue = '#000C36';
const travrondenRed = '#f32016';
const trmediaRed = '#C7051F';

const atgBrandDefaultBetTypeColors: Required<BetTypeColors> = {
  primary: '#00ABEC',
  highlight: '#EBF6FC',
  gradient: ['#298dcd', '#80bde6'],
};

const colors: BaseColors = {
  black: '#000000',
  white: '#ffffff',
  brands: {
    jokersystemet: jokerOrange,
    spelvarde: spelvardeRed,
    storavinster: storavinsterBlue,
    travfakta: travfaktaGreen,
    travogat: travogatLightBlue,
    travronden: travrondenRed,
    travrondenSpel: travrondenSpelBlue,
    trmedia: trmediaRed,
    facebook: '#3b5998',
    twitter: '#38A1F3',
  },
  atg: {
    V75: {
      primary: '#105CD9',
      highlight: '#EEF0F4',
      gradient: ['#1e3480', '#0d57a1'],
    },
    V86: {
      primary: '#9D159F',
      highlight: '#F6E6F6',
      gradient: ['#711970', '#91448f'],
    },
    GS75: {
      primary: '#20744A',
      highlight: '#E2F0EA',
      gradient: ['#2A513F', '#2A724E'],
    },
    V64: {
      primary: '#F66105',
      highlight: '#FEF3E8',
      gradient: ['#e95a0c', '#ef7c22'],
    },
    V65: {
      primary: '#D1182D',
      highlight: '#F8E9EB',
      gradient: ['#a60d1f', '#cc2332'],
    },
    V5: atgBrandDefaultBetTypeColors,
    V4: atgBrandDefaultBetTypeColors,
    V3: atgBrandDefaultBetTypeColors,
    T7: atgBrandDefaultBetTypeColors,
    DD: atgBrandDefaultBetTypeColors,
    LD: atgBrandDefaultBetTypeColors,
    TV: atgBrandDefaultBetTypeColors,
    T: atgBrandDefaultBetTypeColors,
    V: atgBrandDefaultBetTypeColors,
    P: atgBrandDefaultBetTypeColors,
    K: atgBrandDefaultBetTypeColors,
  },
};

export default colors;
